import { useErrorModal } from "../context/ErrorModalContext";

const ErrorIcon = () => (
  <img
    src="/assets/cross.svg"
    width="64"
    height="64"
    alt=""
    className="error-modal-icon"
  />
);

const ErrorModal = () => {
  const { modalState, hideError } = useErrorModal();

  if (!modalState.isOpen) return null;

  const handleButtonClick = (onClick) => {
    if (onClick) {
      onClick();
    }
    hideError();
  };

  const hasNewLayout = modalState.icon || modalState.title;

  const [msgFirst, ...msgRest] = (modalState.message || "").split(/\n+/);
  const messageTitle = msgFirst.trim();
  const messageSubtitle = msgRest.join(" ").trim();

  return (
    <>
      <div className="error-modal-backdrop" />
      <div className="error-modal">
        <div className="error-modal-content">
          {hasNewLayout ? (
            <>
              <ErrorIcon />
              <h2 className="error-modal-title">{modalState.title}</h2>
              {modalState.subtitle && (
                <p className="error-modal-subtitle">{modalState.subtitle}</p>
              )}
            </>
          ) : (
            <>
              <ErrorIcon />
              <h2 className="error-modal-title">{messageTitle}</h2>
              {messageSubtitle && (
                <p className="error-modal-subtitle">{messageSubtitle}</p>
              )}
            </>
          )}
          <div className="error-modal-buttons">
            {modalState.buttons.map((button, index) => (
              <button
                key={index}
                className={`error-modal-button ${button.variant || "primary"}`}
                onClick={() => handleButtonClick(button.onClick)}
              >
                {button.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorModal;
